import { useTranslation } from "react-i18next";

import CurrencyCell from "@/components/ui/v1/table/CurrencyCell";
import { TableLinkCell } from "@/components/ui/v1/table/TableCells";
import { ChannelMonthType } from "@/types/response/ChannelMonthType";
import { TableColumn } from "@/types/table/tableProps";

export const useChannelMonthTableColumns = () => {
  const { t } = useTranslation();

  const channelMonthTableColumns: TableColumn<ChannelMonthType>[] = [
    {
      accessor: "client.name",
      Cell: (row: ChannelMonthType) => (
        <TableLinkCell
          label={row.client?.name || ""}
          link={`/clients/${row.client?.id2}`}
        />
      ),
      header: t("common.client"),
      width: "25%",
    },
    {
      accessor: "budget",
      Cell: (row: ChannelMonthType) => <CurrencyCell value={row.budget} />,
      header: t("common.budget"),
      width: "25%",
      sortable: false,
    },
    {
      accessor: "spent",
      Cell: (row: ChannelMonthType) => (
        <div className="flex justify-end w-full">
          {row.spent === null ? (
            <span>-</span>
          ) : (
            <CurrencyCell value={row.spent} />
          )}
        </div>
      ),
      header: t("common.invoice"),
      width: "20%",
      textAlign: "right",
      sortable: false,
    },
  ];

  return {
    channelMonthTableColumns,
  };
};
